import React, { createContext, useContext, useState } from 'react';
import { PlanCode } from '../../types';

interface BillingSubscribeModalContext {
  isSubscribeModalOpen: boolean;
  subscribeToPlan?: PlanCode;
  openSubscribeModal: (plan: PlanCode) => void;
  closeSubscribeModal: () => void;
}

const BillingSubscribeModalContext =
  createContext<BillingSubscribeModalContext>({
    isSubscribeModalOpen: false,
    subscribeToPlan: undefined,
    openSubscribeModal: () => {},
    closeSubscribeModal: () => {},
  });

export function BillingSubscribeModalProvider({ children }) {
  const [modalData, setModalData] = useState<{
    open: boolean;
    plan?: PlanCode;
  }>({
    open: false,
    plan: undefined,
  });

  const openSubscribeModal = (plan: PlanCode) => {
    setModalData({ open: true, plan });
  };

  const closeSubscribeModal = () => {
    setModalData({ open: false });
  };

  return (
    <BillingSubscribeModalContext.Provider
      value={{
        isSubscribeModalOpen: modalData.open,
        subscribeToPlan: modalData.plan,
        openSubscribeModal,
        closeSubscribeModal,
      }}
    >
      {children}
    </BillingSubscribeModalContext.Provider>
  );
}

export function useBillingSubscribeModal(): BillingSubscribeModalContext {
  const context = useContext(BillingSubscribeModalContext);
  if (context === undefined) {
    throw new Error(
      'useBillingSubscribeModal must be used within a BillingSubscribeModalContext.Provider'
    );
  }
  return context;
}
